import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { MsalService } from '@azure/msal-angular';
import { AccountInfo } from '@azure/msal-common';
import { Observable } from 'rxjs';
import { NewVulnerabilityService } from './new-vulnerability.service';

interface Account extends AccountInfo {
  idTokenClaims?: {
    roles?: string[]
  }
}

@Injectable({
  providedIn: 'root'
})
export class RolegaurdService {

  userRole : boolean = false;
  adminRole : boolean = false;
  constructor(private authService : MsalService,private service : NewVulnerabilityService) { }

  canActivate(route : ActivatedRouteSnapshot) : boolean{
    const expectedRole = route.data.expectedRole;
    console.log("expected Roles : "+expectedRole);
     const allowedRoles = route.data["requiredRole"];
      console.log("allowedRoles roles : "+allowedRoles);
    //  console.log("allowedRoles length : "+allowedRoles.length);
    //  const matchRoles = expectedRole.filter((x: any) => allowedRoles.includes(x));
    //  console.log("match roles : "+matchRoles.length);
    let account: Account = this.authService.instance.getAllAccounts()[0];
    const acc = account;
    console.log("role include : ");
    console.log(account.idTokenClaims?.roles?.includes(expectedRole));
    console.log(account.idTokenClaims?.roles);


    // expectedRole.array.forEach((element: string) => {
    //   account.idTokenClaims.roles.map(
    //     e  => {
    //       if(e.toString() === element.toString()){
    //         //return true;
    //         console.log("into array : "+e.toString());
    //       }
    //     }
    //   )
    // });

    if (!account.idTokenClaims?.roles?.includes(expectedRole) && !account.idTokenClaims?.roles?.includes(allowedRoles)) {
      window.alert('You do not have access as expected role is missing. Please ensure that your account is assigned to an app role and then sign-out and sign-in again.');
      return false;
    }

    return true;
  }

  getRoles() : string[]{
    let account: Account = this.authService.instance.getAllAccounts()[0];
    console.log("account : "+account.idTokenClaims.roles);
    return account.idTokenClaims.roles;
  }

  appUser() : boolean{
    let account: Account = this.authService.instance.getAllAccounts()[0];
    console.log("user bool : "+this.userRole);
    if((account.idTokenClaims.roles[0] == "Users" || account.idTokenClaims.roles[1] == "Users")
       && (account.idTokenClaims.roles[0] != "Admin" || account.idTokenClaims.roles[1] != "Admin")){
      this.userRole = true;
      console.log("user bool2 : "+this.userRole);
    }
    return this.userRole;
    // return false;
  }
  appAdmin() : boolean{
    let account: Account = this.authService.instance.getAllAccounts()[0];
    console.log("admin bool : "+this.adminRole);
    console.log("account : ");
    console.log(account.idTokenClaims.roles.length)
    console.log(account.idTokenClaims.roles[0]);
    console.log(account.idTokenClaims.roles[1]);
    if(account.idTokenClaims.roles[0] == "Admin" || account.idTokenClaims.roles[1] == "Admin"){
      this.adminRole = true;
      console.log("admin bool : "+this.adminRole);
    }
    return this.adminRole;
    // return true;
  }

  //async
  getUserDLDetails():boolean{
    let resultData = "";
    let bValue = false;
    // localStorage.setItem('UserID','sharad.singh.singh@accenture.com');

    //await
      this.service.userDLDetails(
      localStorage.getItem('UserID').substring(0, localStorage.getItem('UserID').lastIndexOf("@"))
    ).subscribe//toPromise().then
    ((res : any) => {
             resultData = res;

         }, (error:any) => {
          //  this.errormessage = error;
          alert(error +" cust");
          console.log("er msg "+error.message);
       });

       if(resultData != ""){
        if(resultData == "FromGCC")
        {
         bValue = true;
        }
        else{
         bValue = false;
        }

       }
       console.log("resultData "+resultData);
       return bValue;
  }

  verifyUserID() : boolean{
    let verEID = "";
    let boolValue = false
    this.service.verifyContEid(
      "robert.wardle"
    ).subscribe(res => {
      verEID = res.toString();

      if(verEID != ""){
        if(verEID == "Ok")
        {
         boolValue= true;
        }
        else{
          boolValue= false;
        }
      }
    });


    return boolValue;
  }

}
